export type EditorStep = 'welcome' | 'people' | 'numbers' | 'generosity' | 'review' | 'thanks';

export const EDITABLE_STEPS: EditorStep[] = ['people', 'numbers', 'generosity', 'review'];

export const nextStep = (current: EditorStep): EditorStep | null => {
  const idx = EDITABLE_STEPS.indexOf(current);
  if (idx < 0 || idx >= EDITABLE_STEPS.length - 1) return null;
  return EDITABLE_STEPS[idx + 1];
};

export const prevStep = (current: EditorStep): EditorStep | null => {
  const idx = EDITABLE_STEPS.indexOf(current);
  if (idx <= 0) return 'welcome';
  return EDITABLE_STEPS[idx - 1];
};
